import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'experienceShortNameFilter'
})
export class ExperienceShortNameFilterPipe implements PipeTransform {
    transform(items: any[], filterIds: string[]): any[] {
        if (!items) {
            return [];
        }

        return items.filter(item => filterIds.some(x => x === item.experienceShortName));
    }
}



// WEBPACK FOOTER //
// ./src/app/_pipes/experience-short-name-filter.pipe.ts